/**
 * Activation, confirm-registration, and tenant-invite-acceptance links are themselves the mechanism
 * that grants tenant access — visiting them while logged in as an account that doesn't have access
 * YET (e.g. pending admin approval, or a stale session for an unrelated tenant) must let the page
 * render its own state (pending-approval, invalid/expired link, etc.), not bounce to /no-access.
 */
export const isAccessGrantingAuthFlow = (pathname: string): boolean =>
    /\/auth\/(activate|confirm-registration|accept-invitation)(\/|$)/.test(pathname);
